module.exports = __webpack_public_path__ + "static/media/4.1ddb6f5e.png";